import AppDispatcher from '../utils/AppDispatcher';
import { EventEmitter } from 'events';
import { events as StatusEvents, actions as StatusActions } from '../constants/StatusConstants';

var _state = {
    statusSummary: null,
    statusError: null,
};

class AppStatusStoreClass extends EventEmitter {

    getState() {
        return _state;
    }

    emitChange(event) {
        this.emit(event);
    }

    addChangeListener(event, callback) {
        this.on(event, callback);
    }

    removeChangeListener(event, callback) {
        this.removeListener(event, callback);
    }

    get error() {
        return _state.statusError;
    }

    get statusSummary() {
        return _state.statusSummary;
    }

    reloadStatus() {
        let self = this;
        $.ajax({
            url: 'https://2bwxxv3tk983.statuspage.io/api/v2/summary.json',
            type:'GET',
            xhrFields: {
                withCredentials: true
            },
            success: function(data) {
                _state.statusSummary = data;
                _state.statusError = null;
                self.emitChange(StatusEvents.STATUS_RELOADED);
            },
            error:function(data) {
                _state.statusSummary = null;
                _state.statusError = 'Error retreiving current status';
                self.emitChange(StatusEvents.STATUS_RELOADED);
            },
        });
    }
}

const AppStatusStore = new AppStatusStoreClass();

AppStatusStore.dispatchToken = AppDispatcher.register(action => {

    switch(action.actionType) {

    case StatusActions.RELOAD_STATUS:
        AppStatusStore.reloadStatus();
        break;

    }
});

export default AppStatusStore;



// WEBPACK FOOTER //
// ./ui_src/app/stores/AppStatusStore.jsx